













import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import moment from 'moment-timezone'
import { timeAgo, unitTimezone } from '@/_utils/datetime'

@Component({
  components: {},
})
export default class LastUpdatedJbox extends Vue {
  // Props
  @Prop()
  datetime!: any

  timeAgo: any = timeAgo
  key: number = 1

  get unitDatetime(): string {
    const format = 'YYYY-MM-DD H:m:s'
    return moment(this.datetime).tz(unitTimezone()).format(format)
  }

  get timeAgoText(): string {
    return this.key && this.timeAgo(this.datetime)
  }

  mounted() {
    setInterval(() => {
      // To make time ago re-render continuous.
      this.key++
    }, 1000)
  }
}
